import React from 'react';
import { Outlet } from 'react-router-dom';

import RunOutSubscriptionModal from './components/RunOutSubscriptionModal';

import styles from './App.module.scss';

function App() {
  return (
    <>
      {/* TODO: Header */}
      <main>
        <Outlet />
      </main>
      {/* TODO: Footer */}
      <RunOutSubscriptionModal />
    </>
  );
}

export default App;
